import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/msalConfig";

/**
 * MSAL Instance - Single instance for the entire application
 */
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect promise immediately
let initializationPromise = null;

export const initializeMsal = async () => {
  if (!initializationPromise) {
    initializationPromise = (async () => {
      try {
        await msalInstance.initialize();
        
        // Handle redirect promise
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
          console.log("Sign-in successful after redirect", response);
          return response;
        }
      } catch (error) {
        console.error("MSAL initialization error:", error);
        throw error;
      }
    })();
  }
  return initializationPromise;
};
